import { compose } from 'recompose';
import { connect } from 'react-redux';
import { actions } from 'reducers';

const mapDispatchToProps = {
  listenAuth: actions.auth.listen
};

export default compose(connect(null, mapDispatchToProps));



// WEBPACK FOOTER //
// ./src/components/login/enhance.js